document.addEventListener("DOMContentLoaded", function () {
  const accordionSections = document.querySelectorAll(".accordion-section");

  accordionSections.forEach((section) => {
    const accordionItems = section.querySelectorAll(".accordion-item");

    const firstItem = accordionItems[0];
    if (firstItem) {
      const firstContent = firstItem.querySelector(".paccordion-content");
      if (firstContent) {
        firstItem.classList.add("pactive");
        firstContent.style.maxHeight = firstContent.scrollHeight + "px";
      }
    }

    accordionItems.forEach((item) => {
      const header = item.querySelector(".accordion-header");
      const content = item.querySelector(".paccordion-content");

      if (!header || !content) return;

      header.addEventListener("click", () => {
        const isOpen = item.classList.contains("pactive");

        //  If already open → just close it
        if (isOpen) {
          item.classList.remove("pactive");
          content.style.maxHeight = null;
          return;
        }

        // Otherwise, close others in this section
        accordionItems.forEach((el) => {
          const elContent = el.querySelector(".paccordion-content");
          el.classList.remove("pactive");
          if (elContent) elContent.style.maxHeight = null;
        });

        // Open clicked one
        item.classList.add("pactive");
        content.style.maxHeight = content.scrollHeight + "px";
      });
    });
  });
});